import { useEffect } from "react"
import { useTranslation } from "next-i18next"
import { useSelector } from "react-redux"
import { getCheckoutIdApi } from "@/services/index"
import Button from "@/components/core/Button/Button"

import { selectGenericState } from "@/store/features/genericSlice"
import { selectAuthState } from "@/store/features/authSlice"
import { selectCartState } from "@/store/features/cartSlice"

import { DOMAIN } from "@/constants/"

import { aciPaymentWidgetsInit } from "@/utils/payment"
import { getQuantityCount } from "@/utils/cart"

import { getTranslations } from "@/components/Shared/ExpressCheckout/localization"
import Style from "@/components/Shared/ExpressCheckout/index.module.scss"
import { addExpressPaypalAnalyticsData } from "@/components/Shared/ExpressCheckout/analytics"
import payPalImage from "@/public/images/paypal.svg"

const ExpressCheckout = props => {
  const {
    orderSummary: isOrderSummary = false,
    productData = {},
    isOutOfStock = false,
  } = props || {}
  const productInfo = productData?.productInfo || {}

  const { globalConfig = {}, featureFlags = {} } =
    useSelector(selectGenericState)

  const { user: { koc: isIscUser = "" } = {} } = useSelector(selectAuthState)
  const { cart: activeCart } = useSelector(selectCartState)

  const {
    general: { checkoutPagePath = "" } = {},
    apiEndpoints: { paypalMerchantId = "" } = {},
  } = globalConfig

  const { lineItems = [] } = activeCart

  const {
    MYSQLCONNSTR_ENABLE_PAYPAL_EXPRESS_CHECKOUT: isPaypalExpCheckout = false,
  } = featureFlags

  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  const { orLabel = "", titleLabel = "", messageLabel = "" } = staticText

  window.wpwlOptions = {
    inlineFlow: ["PAYPAL"],
    styling: {
      layout: "vertical",
      label: "checkout",
      height: 50,
      borderRadius: 0,
      color: "gold",
    },
    fundingSources: ["PAYPAL"],
    paypal: {
      merchantId: paypalMerchantId,
      createRegistration: "true",
      sdkParams: {
        "disable-funding": "card,paylater,credit",
      },
      onClick: () => {
        addExpressPaypalAnalyticsData({ isOrderSummary, productInfo })
      },
    },
    onError: error => {
      console.log("onError", error)
    },
  }

  window.wpwlOptions.createCheckout = async function (json) {
    const id = await getCheckoutIdApi()
    sessionStorage.setItem("payId", id)
    return id
  }

  const quantity = getQuantityCount(lineItems)

  const isPayPal = isPaypalExpCheckout && !isIscUser && quantity > 0

  useEffect(() => {
    if (isPayPal) {
      aciPaymentWidgetsInit(true)

      return () => {
        aciPaymentWidgetsInit(false)
      }
    }
  }, [isPayPal])

  if (isPayPal) {
    return (
      <div className={`${Style.ExpressCheckout} ExpressCheckoutGroup`}>
        <div className="divider">{orLabel}</div>
        <div className="heading">{titleLabel}</div>
        {isOutOfStock ? (
          <Button
            customClass="disabled-paypal-button"
            label={"Checkout"}
            type="primary"
            disabled={isOutOfStock}
            image={payPalImage}
            flexible
          />
        ) : null}

        <div className={isOutOfStock ? "d-none" : ""}>
          <form
            action={`${DOMAIN}${checkoutPagePath}?pm=xpp`}
            className="paymentWidgets"
            data-brands="PAYPAL"
          />
        </div>

        {isOrderSummary ? <p className="message">{messageLabel}</p> : null}
      </div>
    )
  } else return ""
}

export default ExpressCheckout
